<template>
  <div class="dialogBox">
    <el-dialog
      :visible.sync="dialogVisible"
      width="40%"
      @close="close"
      destroy-on-close
      title="AI推广文字生成"
    >
      <h4>
        请先填写商品介绍，例如商品名称、制作工艺、商品产地、商品特点等，我们会帮您生成合适的商品推广文案。
      </h4>
      <el-input
        v-model="text"
        class="tip_ipt"
        placeholder="再此处输入1000字以内的产品介绍"
        type="textarea"
        :rows="20"
        maxlength="1000"
        show-word-limit
      ></el-input>
      <div class="footer">
        <el-button class="btn" type="primary" @click="queryGeneralAiWrite"
          >生成推广文案</el-button
        >
      </div>
      <div v-if="isShow">
        <el-input
          v-model="textValue"
          class="tip_ipt"
          placeholder="AI生成文案"
          type="textarea"
          :rows="30"
        ></el-input>
        <div class="footer">
          <el-button class="btn" type="warning" @click="openNewGenerat"
            >重新生成</el-button
          >
          <el-button class="btn" type="success" :disabled ='!canUse'  @click="useAiWrite"
            >使用该文案</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible1"
      width="30%"
      destroy-on-close
      title="AI推广文字生成"
    >
      <h4>文案不合适？您可以选择以下标签重新生成</h4>
      <el-radio-group v-model="radioText">
        <el-radio label="重点突出产品特点" border></el-radio>
        <el-radio label="更让人有购买欲望" border></el-radio>
        <el-radio label="让文案跟适合线上推广" border></el-radio>
        <el-radio label="其他需求" border></el-radio>
      </el-radio-group>
      <el-input
        v-model="radioText"
        class="tip_txt"
        placeholder="再此处输入100字以内的产品介绍"
        type="textarea"
        :rows="20"
        maxlength="1000"
        show-word-limit
      ></el-input>
      <div class="footer">
        <el-button class="btn" type="warning" @click="already()"
          >重新生成</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reqGeneralAiWriteList } from "@/assets/api/aiProduct";
import { EventSourcePolyfill } from "event-source-polyfill";

export default {
  data() {
    return {
      isShow: false,
      loading: false,
      dialogVisible: false,
      dialogVisible1: false,
      text: "",
      textValue: "",
      radioText: "",
      eventSource: null,
      connectionStatus: "未连接",
      canUse:false
    };
  },
  methods: {
    // 使用文案
    useAiWrite() {
      this.$emit("useAiWrite", this.textValue);
      this.dialogVisible = false;
    },
    // 重新生成
    openNewGenerat() {
      this.dialogVisible1 = true;
    },
    // 生成AI文字
    async queryGeneralAiWrite() {
        const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (!this.text) return ElMessage.warning("请输入产品提示词文案!");
      const result = await reqGeneralAiWriteList({
        status: 0,
        pageSize: 10,
        pageNo: 1,
      });

      this.closeSSE();
      const params = new URLSearchParams({
        content: this.radioText || this.text,
        model: result.data?.data?.records[0].model,
      });
      const url =
        process.env.VUE_APP_API +
        `/aistream/api/merchant/digital/human/ai-text/generate?${params.toString()}`;
      this.eventSource = new EventSourcePolyfill(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
          withCredentials: true,
        },
      });

      this.eventSource.onopen = (e) => {
        this.connectionStatus = "已连接";
        this.textValue = "";
        // this.dialogVisible1=false
        // console.log("SSE连接已建立", e);
      };
      // 成功接收
      this.eventSource.onmessage = (e) => {
        loading.close();
        this.isShow = true;
        this.textValue += JSON.parse(
          e.data
        )?.data?.output?.choices[0]?.message?.content;
        if (
          JSON.parse(e.data)?.data?.output?.choices[0]?.finishReason == "stop"
        ) {
          this.closeSSE();
          this.canUse = true
        }
      };

      this.eventSource.onerror = (e) => {
        if (e.readyState === EventSource.CLOSE) {
          this.connectionStatus = "连接已关闭";
        } else {
          this.connectionStatus = "连接异常";
        }
      };
    },
    // 重新生成
    already() {
      this.dialogVisible1 = false;
      this.queryGeneralAiWrite();
    },
    // 关闭弹窗
    close() {
      this.closeSSE();
      this.text = "";
      this.textValue = "";
      this.isShow = false;
    },
    closeSSE() {
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
    },
    open() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
h4 {
  margin-bottom: 10px;
}
.footer {
  display: flex;
  justify-content: right;
  .btn {
    margin-top: 15px;
    margin-bottom: 10px;
  }
}
.tip_txt {
  margin-top: 10px;
}
</style>
